{
  "groups": {
    "referenceNumber": "Reference Number",
    "appointmentStartTimes": "Appointment Start Times",
    "appointmentNotifications": "Appointment Notifications",
    "appointmentStatuses": "Appointment Statuses",
    "customAppointmentsGrid": "Custom Appointments Grid",
    "limiter": "Limiter",
    "schedulingPortal": "Scheduling Portal",
    "dockSelection": "Dock Selection",
    "timeDisplay": "Time Display",
    "gateManagement": "Gate Management",
    "smartGate": "SmartGate",
    "idValidation": "ID Validation",
    "appointmentValidation": "Appointment Validation",
    "other": "Other",
    "handlingUnits": "Handling Units"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Determine the time intervals at which appointments will be allowed to start.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "Manage all types of appointment notifications for this {entity}.",
    "manageTheSchedulingPortalSettingsForThisEntity": "Manage the Scheduling Portal settings for this {entity}",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "Handling Units is a numeric field for requesting units (e.g. pallets) during appointment scheduling. Add it to your form to also enable the Limiter feature.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "The Limiter allows you to set a maximum number of appointments or handling units (e.g. pallets) that can be scheduled per day."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "Minimum Amount of Reference Numbers",
    "maximumAmountOfReferenceNumbers": "Maximum Amount of Reference Numbers",
    "includeReferenceNumberFieldOnAllAppointmentForms": "Include Reference Number field on all appointment forms?",
    "referenceNumberFieldName": "Reference Number field name",
    "referenceNumberHelperText": "Reference Number helper text",
    "makeReferenceNumberARequiredField": "Make Reference Number a required field?",
    "allowAppointmentsForThisEntityToStartAt": "Allow appointments for this {entity} to start at:",
    "enableAppointmentNotificationsForThisEntity": "Enable appointment notifications for this {entity}?",
    "selectEachDesiredStartTimeIndividually": "Select each desired start time individually",
    "hideTheLoadTypeDuration": "Hide the load type duration?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Upload your {entity} logo to display it in the Scheduling Portal and in all email notifications",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Upload your warehouse yard map to display it in the Scheduling Portal",
    "statusForNewlyCreatedAppointments": "Status for newly created appointments",
    "muteAppointmentNotifications": "Mute Appointment Notifications",
    "allowDockSelectionInSchedulingPortal": "Allow Dock selection in Scheduling Portal?",
    "theStatusThatFollowsArrivedIs": "The status that follows 'Arrived' is",
    "displayTimeIn": "Display time in:",
    "customizeAppointmentDetails": "Customize appointment details",
    "gridTileConfig": "Grid tile config",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Enforce geofencing to require drivers to provide their real time location",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "Would you like to show additional information to the drivers after they check in? (optional)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "Prevent rescheduling appointments in the Scheduling Portal?",
    "revertToRequestedOnCarrierReschedule": "Revert to Requested on carrier reschedule",
    "observationMatchAttribute": "Observation Match Attribute",
    "observationMatchTimeWindow": "Observation Match Time Window",
    "autoDepartAssets": "Auto depart Assets",
    "autoCreateAssets": "Auto create Assets",
    "gateFeedColumns": "Gate Feed Columns",
    "checkInEarlyThreshold": "Check-in Early Threshold",
    "checkInLateThreshold": "Check-in Late Threshold",
    "technicalContactEmailAddress": "Technical Contact Email Address",
    "technicalContactEmailThrottleMinutes": "Technical Contact Email Throttle Minutes",
    "requireUniqueReferenceNumbers": "Require Unique Reference Numbers",
    "appointmentStartTimeInterval": "Appointment Start Time Interval",
    "referenceNumberInputMode": "Reference Number Input Mode",
    "uploadWarehouseYardMap": "Upload your warehouse yard map to display it in the Scheduling Portal",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "Include Handling Units field on all appointment forms?",
    "handlingUnitsLabel": "Handling Units Label",
    "handlingUnitsHelperText": "Handling Units Helper Text",
    "makeHandlingUnitsARequiredField": "Make Handling Units a required field?",
    "maximumHandlingUnitsValueForAnAppointment": "Maximum Handling Units value for an appointment",
    "minimumHandlingUnitsValueForAnAppointment": "Minimum Handling Units value for an appointment",
    "checkOutBolSignedRequired": "Check-out BOL Signed Required",
    "requireBolPrinting": "Require BOL Printing",
    "checkOutBolNotLoadingErrorMessage": "Check-out BOL not loading error message",
    "checkOutIdentifier": "Check-out Identifier",
    "enableCheckInIdValidationPersona": "Enable check-in ID validation (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "Require check-in ID validation to complete check-in",
    "checkInIdValidationTemplate": "Check-in ID validation template",
    "geofenceRadius": "Geofence Radius",
    "geofenceRadiusUnit": "Geofence Radius Unit",
    "createAppointmentOnExternalValidationFailure": "Create appointment on external validation failure",
    "enableOverrideLimiterFunction": "Enable Override Limiter Function",
    "receiveUnplannedCheckInEmailNotifications": "Receive Unplanned Check-in Email Notifications",
    "driversMustEnterAReferenceNumberToCheckIn": "Drivers must enter a reference number to check in",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "Drivers can only check in if the reference number matches the scheduled appointment",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "Drivers skip the reference number step during check-in",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "Customize the first SMS message drivers receive after check-in (optional)",
    "includeYardMapImageInTheFirstCheckInSms": "Include Yard Map image in the first check-in SMS?",
    "automaticallyDeleteStoredIdValidations": "Automatically delete stored ID validations",
    "deleteStoredIdValidationsAfter": "Delete stored ID validations after",
    "displayDatesAs": "Display dates as:",
    "displayTimeAs": "Display time as:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Require at least this amount of reference numbers for an appointment",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Require at most this amount of reference numbers for an appointment",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "The display name for the Reference Number field. Eg: \"PO Number\", \"Shipment ID\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "Additional information to help fill in the Reference Number field.  Eg: \"Reference Number should start with OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Require the Reference Number for all appointments being scheduled",
    "thisOnlyAffectsNewlyCreatedAppointments": "This only affects newly created appointments",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Allow Dock selection when booking an appointment in the Scheduling Portal",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "This setting will allow the choice of an alternate 'In Progress' status between 'Arrived' and 'Completed'",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Enable to switch to the new customizable appointment details system",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "User configuration of how grid tiles will be displayed.",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.",
    "preventCarriersFromReschedulingAppointmentsOptional": "Prevent carriers from rescheduling appointments. (optional)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "When a carrier reschedules a Scheduled appointment, move it back to Requested for re-approval",
    "attributeToBeUsedForMatchingObservations": "Attribute to be used for matching observations",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "The number of minutes to account for an observation before and after the check-in time",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "The number of minutes before the appointment start time that a carrier can check in",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "The number of minutes after the appointment start time that a carrier can check in",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Email address where technical issues and information will be sent",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "The time between notifications sent to the technical contact when a validation server error occurs.",
    "aListOfMutedAppointmentNotifications": "A list of muted appointment notifications.",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Require unique Reference Numbers for all appointments being scheduled",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "This is the interval minutes between when appointments can start",
    "enableTheCustomAppointmentStartTimesSetting": "Enable the custom appointment start times setting",
    "theInputModeForTheReferenceNumberField": "The input mode for the reference number field",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "The display name for the unit type field. Eg: Pallet Count, Skid Count",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "Require the unit type field for all appointments being scheduled",
    "autoDepartAssetsOnReceivingOutgateEvent": "Auto depart assets on receiving outgate event",
    "autoCreateAssetsOnReceivingIngateEvent": "Auto create assets on receiving ingate event",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "Columns available on the AI Gate Feed page. Required columns are always shown.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "Create appointments even if appointment validation does not pass",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "The radius in miles that the driver must be within to check in. This is only applicable if geofencing is enabled.",
    "theDistanceUnitTheGeofenceRadiusIsMeasuredIn": "The distance unit the geofence radius is measured in.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "Additional information to help fill in the unit type field. Eg: Unit Type should be only numbers",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Sets the maximum numeric value that can be entered for the Handling Units field on an appointment",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Sets the minimum numeric value that can be entered for the Handling Units field on an appointment",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "When the limiter is 100% reached, this feature allows only warehouse users to override and create or approve appointments and units",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "The asset attribute the system will use to validate the check-out form",
    "enforceBolSigningOnCheckOutForm": "Enforce BOL signing on check-out form",
    "driverMustPrintTheBolToCompleteTheCheckoutWithAPhysicalSignature": "Driver must print the BOL to complete the checkout with a physical signature.",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "If the BOL is not available, the carrier will not be able to sign it, thus the check-out would be blocked. Here, you can set custom instructions that the driver will see in case this happens.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "Show the Persona component in the check-in flow for identity verification",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "Require successful Persona validation before the driver can complete check-in",
    "personaTemplateUsedForCheckInIdentityVerification": "Persona template used for check-in identity verification",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "Warehouse subscribers receive email notifications when an unplanned check-in occurs",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "This message replaces the default check-in confirmation text sent to the driver by SMS. Leave blank to use the default message.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "Sends your Yard Map as a separate image message right after the check-in SMS. Requires a Yard Map to be uploaded for this warehouse.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "Stored ID validation records are permanently deleted once the retention period has passed",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "Number of days a stored ID validation is kept before it is deleted",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determine how dates will be displayed for users of this company across company-facing experiences.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determine how time will be displayed for users of this company across company-facing experiences."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "Reference Number associated with appointment",
    "insertMessageHere": "Insert message here"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "Top of the hour (:00)",
      "topAndBottomOfTheHour00And30": "Top and bottom of the hour (:00 and :30)",
      "everyTwentyMinutes0020And40": "Every Twenty Minutes (:00, :20, and :40)",
      "everyQuarterOfTheHour001530And45": "Every quarter of the hour (:00, :15, :30, and :45)",
      "customStartTimes": "Custom start times"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 Minutes",
      "30Minutes": "30 Minutes",
      "60Minutes": "60 Minutes",
      "90Minutes": "90 Minutes"
    },
    "observationMatchAttribute": {
      "licensePlate": "License Plate",
      "dotNumber": "DOT Number",
      "any": "Any",
      "cascade": "Cascade"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "Alphanumeric",
      "numeric": "Numeric"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "Scheduled",
      "requested": "Requested"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "In Progress",
      "completed": "Completed"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "No, don't include the Reference Number field",
      "yesIncludeTheReferenceNumberField": "Yes, include the Reference Number field"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "No, don't hide the Load Type duration",
      "yesHideTheLoadTypeDuration": "Yes, hide the Load Type duration"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "No, disable appointment notifications",
      "yesEnableAppointmentNotifications": "Yes, enable appointment notifications"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "No, don't allow Dock selection",
      "yesAllowTheDockSelection": "Yes, allow the Dock selection"
    },
    "displayTimeIn": {
      "regularTime12Hour": "Regular time (12-hour)",
      "militaryTime24Hour": "Military time (24-hour)"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "Allow rescheduling in the Scheduling Portal ",
      "preventReschedulingInTheSchedulingPortal": "Prevent rescheduling in the Scheduling Portal"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "Revert to Requested on carrier reschedule",
      "keepStatusUnchangedOnCarrierReschedule": "Keep status unchanged on carrier reschedule"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "No, don't make Reference Number a required field",
      "yesMakeReferenceNumberARequiredField": "Yes, make Reference Number a required field"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "No, don't require unique Reference Numbers",
      "yesRequireUniqueReferenceNumbers": "Yes, require unique Reference Numbers"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "No, don't make Handling Units a required field",
      "yesMakeHandlingUnitsARequiredField": "Yes, make Handling Units a required field"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "No, don't include the Handling Units field",
      "yesIncludeTheHandlingUnitsField": "Yes, include the Handling Units field"
    },
    "checkOutIdentifier": {
      "licensePlate": "License Plate",
      "phoneNumber": "Phone Number",
      "any": "Any"
    },
    "geofenceRadiusUnit": {
      "miles": "Miles",
      "kilometers": "Kilometers"
    },
    "enableCheckInIdValidationPersona": {
      "no": "No",
      "yes": "Yes"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "No",
      "yes": "Yes"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "Driver license - Front - 1 retry",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "Driver license - Front, barcode, face, us only, 1 retry"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "No",
      "yes": "Yes"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "Tue, MM/DD/YYYY",
      "tueDdMmYyyy": "Tue, DD/MM/YYYY",
      "tueYyyyMmDd": "Tue, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12-hour (e.g. 7:00 AM)",
      "24HourEG0700": "24-hour (e.g. 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "E.g. 7:00 AM / 7:00 PM",
      "eG07001900": "E.g. 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "Note:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "If left empty, the default name will be applied",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "If left empty, the default helper text will be applied",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Enabling this option does not impact notifications that are already disabled on the appointment level individually.",
    "ifLeftEmptyNoNotificationsWillBeSent": "If left empty, no notifications will be sent",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "Reference number assigned to cancelled or no show appointments may be reused on new appointments",
    "ifEmptyTheDefaultNameWillBeApplied": "If empty, the default name will be applied"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "Drivers",
    "checkInSms": "Check-in SMS",
    "dataRetention": "Data Retention"
  }
}
